<script setup>
import { inject, computed } from "vue";
import ChargemapMenuSection from "./ChargemapMenuSection.vue";
import ChargemapMenuLink from "./ChargemapMenuLink.vue";
const props = defineProps({
  link: {
    type: Object,
    required: true
  },
  isBig: {
    type: Boolean,
    default: false
  }
});
const subMenuState = inject("subMenuState");
const showSubMenu = computed(
  () => subMenuState?.activeSubMenuId.value === props.link.id
);
const handleClick = () => {
  if (subMenuState?.activeSubMenuId.value === props.link.id) {
    subMenuState.setActiveSubMenu(null);
  } else {
    subMenuState?.setActiveSubMenu(props.link.id);
  }
};
</script>

<template>
    <div
        :class="{
  'border border-primary-500 rounded-md': showSubMenu && !isBig
}"
    >
        <ChargemapMenuLink
            class="cursor-pointer"
            :link
            is-sub-menu
            :is-big
            :is-sub-menu-active="showSubMenu"
            @click="handleClick"
        />
        <div
            class="overflow-hidden transition-[max-height] ease-linear duration-500 max-h-0"
            :class="showSubMenu && 'max-h-80'"
        >
            <ChargemapMenuSection
                class="mt-1"
                :class="isBig ? 'pl-2' : 'pl-0'"
                is-sub-menu-link
                :list-links="link.linksSubMenu || []"
                :is-big
            />
        </div>
    </div>
</template>
